
import Vue from 'vue'

const locales = {keys(){return []}}
global['____3C559FF____'] = true;
delete global['____3C559FF____'];
global.__uniConfig = {"globalStyle":{"navigationBarTextStyle":"black","navigationBarTitleText":"uni-app","navigationBarBackgroundColor":"#F8F8F8","backgroundColor":"#F8F8F8"},"uniIdRouter":{},"preloadRule":{"pages/index/login":{"network":"all","packages":["pages/login"]}}};
global.__uniConfig.compilerVersion = '4.84';
global.__uniConfig.darkmode = false;
global.__uniConfig.themeConfig = {};
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '__UNI__3C559FF';
global.__uniConfig.appName = 'SKSHOP';
global.__uniConfig.appVersion = '1.0.0';
global.__uniConfig.appVersionCode = '100';
global.__uniConfig.router = {"mode":"history","base":"/"};
global.__uniConfig.publicPath = "/";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {};
global.__uniConfig.qqMapKey = undefined;
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.aMapKey = undefined;
global.__uniConfig.aMapSecurityJsCode = undefined;
global.__uniConfig.aMapServiceHost = undefined;
global.__uniConfig.locale = "";
global.__uniConfig.fallbackLocale = undefined;
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-index-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/code/front/zhanhui_info/pages/index/index"+'.vue')), 'pages-index-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-index-login', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/code/front/zhanhui_info/pages/index/login"+'.vue')), 'pages-index-login'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-index-cate', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/code/front/zhanhui_info/pages/index/cate"+'.vue')), 'pages-index-cate'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-index-cart', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/code/front/zhanhui_info/pages/index/cart"+'.vue')), 'pages-index-cart'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-index-home', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/code/front/zhanhui_info/pages/index/home"+'.vue')), 'pages-index-home'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-index-404', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/code/front/zhanhui_info/pages/index/404"+'.vue')), 'pages-index-404'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-h5', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/code/front/zhanhui_info/pages/login/h5"+'.vue')), 'pages-login-h5'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-register', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/code/front/zhanhui_info/pages/login/register"+'.vue')), 'pages-login-register'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-find', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/code/front/zhanhui_info/pages/login/find"+'.vue')), 'pages-login-find'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-weChatAccount', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/code/front/zhanhui_info/pages/login/weChatAccount"+'.vue')), 'pages-login-weChatAccount'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-weChatMiniapp', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/code/front/zhanhui_info/pages/login/weChatMiniapp"+'.vue')), 'pages-login-weChatMiniapp'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-info-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/code/front/zhanhui_info/pages/info/index"+'.vue')), 'pages-info-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-info-submitOk', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/code/front/zhanhui_info/pages/info/submitOk"+'.vue')), 'pages-info-submitOk'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-info-write', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/code/front/zhanhui_info/pages/info/write"+'.vue')), 'pages-info-write'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-info-select', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("F:/code/front/zhanhui_info/pages/info/select"+'.vue')), 'pages-info-select'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/index/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,

          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom"})
      },
      [
        createElement('pages-index-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-index-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/index',
isQuit:true,
isEntry:true,
  windowTop:0
}
},
{
path: '/pages/index/login',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"用户登录","navigationStyle":"custom"})
      },
      [
        createElement('pages-index-login', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-index-login',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/login',
  windowTop:0
}
},
{
path: '/pages/index/cate',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品分类","navigationStyle":"custom"})
      },
      [
        createElement('pages-index-cate', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-index-cate',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/cate',
  windowTop:0
}
},
{
path: '/pages/index/cart',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"购物车","navigationStyle":"custom"})
      },
      [
        createElement('pages-index-cart', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-index-cart',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/cart',
  windowTop:0
}
},
{
path: '/pages/index/home',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"个人中心","navigationStyle":"custom"})
      },
      [
        createElement('pages-index-home', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-index-home',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/home',
  windowTop:0
}
},
{
path: '/pages/index/404',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"404 页面未找到","navigationStyle":"custom"})
      },
      [
        createElement('pages-index-404', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-index-404',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/404',
  windowTop:0
}
},
{
path: '/pages/login/h5',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"用户登录","navigationStyle":"custom"})
      },
      [
        createElement('pages-login-h5', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-h5',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/h5',
  windowTop:0
}
},
{
path: '/pages/login/register',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"用户注册","navigationStyle":"custom"})
      },
      [
        createElement('pages-login-register', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-register',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/register',
  windowTop:0
}
},
{
path: '/pages/login/find',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"忘记密码","navigationStyle":"custom"})
      },
      [
        createElement('pages-login-find', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-find',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/find',
  windowTop:0
}
},
{
path: '/pages/login/weChatAccount',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"公众号授权登录","navigationStyle":"custom"})
      },
      [
        createElement('pages-login-weChatAccount', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-weChatAccount',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/weChatAccount',
  windowTop:0
}
},
{
path: '/pages/login/weChatMiniapp',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"小程序授权登录","navigationStyle":"custom"})
      },
      [
        createElement('pages-login-weChatMiniapp', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-weChatMiniapp',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/weChatMiniapp',
  windowTop:0
}
},
{
path: '/pages/info/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"信息收集","navigationStyle":"custom"})
      },
      [
        createElement('pages-info-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-info-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/info/index',
  windowTop:0
}
},
{
path: '/pages/info/submitOk',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"提交成功","navigationStyle":"custom"})
      },
      [
        createElement('pages-info-submitOk', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-info-submitOk',
  isNVue:false,maxWidth:0,
  pagePath:'pages/info/submitOk',
  windowTop:0
}
},
{
path: '/pages/info/write',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"信息核销","navigationStyle":"custom"})
      },
      [
        createElement('pages-info-write', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-info-write',
  isNVue:false,maxWidth:0,
  pagePath:'pages/info/write',
  windowTop:0
}
},
{
path: '/pages/info/select',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"信息核销","navigationStyle":"custom"})
      },
      [
        createElement('pages-info-select', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-info-select',
  isNVue:false,maxWidth:0,
  pagePath:'pages/info/select',
  windowTop:0
}
},
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
